<template>
	<div>
		<slot name="contact" v-bind="this"></slot>
	</div>
</template>

<script>
export default {
	data() {
		return {
			contactName: "",
			contactEmail: "",
			contactPhone: "",
			submited: false,
			patternText:/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s[a-zA-ZÀ-ÿ\u00f1\u00d1])*[a-zA-ZÀ-ÿ\u00f1\u00d1]+([a-zA-Z\sÁÉÍÓÚáéíóúÑñ]+)$/,
			patternEmail: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/,
			patternPhone: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
		}
	},
	computed: {
		errorFormatName:function () {
			return this.contactName.trim() !== "" && !this.patternText.test(this.contactName);
		},
		errorEmptyEmail:function () {
			return !this.contactEmail || this.contactEmail.trim() == "";
		},
		errorFormatEmail:function () {
			return this.contactEmail.trim() !== "" && !this.patternEmail.test(this.contactEmail);
		},
		errorFormatTel:function () {
			return this.contactPhone.trim() !== "" && !this.patternPhone.test(this.contactPhone);
		}
	},
	methods: {
		testKeyTel(e) {
			if(e.target.value.length < 16 && (e.code.startsWith("Digit") || e.code.startsWith("Backspace") || e.key === "-" || e.key === "+" || e.code.startsWith("Space"))) {
				this.contactPhone = e.target.value;
			} else {
				e.target.value = this.contactPhone;
			}
		},
		blockFlow() {
			return this.errorFormatName || this.errorEmptyEmail || this.errorEmptyEmail || this.errorFormatTel;
		},
		preventSubmit(e) {
			if(this.blockFlow()){
				e.preventDefault();
				this.submited = true;
			}
		}
	}
}
</script>
